import styled from 'styled-components';
import { VISUALIZATION_CONTENT_CONTAINER_CLASS_NAME } from '@ardoq/global-consts';
import { classes } from '@ardoq/common-helpers';

/**
 * This is used for determining what should be included in exported file (e.g. we don't want to include zoom in\zoom out elements).
 * You need to wrap the main content of your exported view in order to place legend correctly in exported file.
 * You can easily adjust styling of the component for export and e.g. add extra padding following this approach:
 *
 * export const ViewContainer = styled.div`                       <- this is your styled component
 *    ...
 *
 *   &.forExport {
 *      ...
 *
 *     ${ExportableViewContentContainer} {
 *       background-color: lime; // <- add extra styles here
 *   }
 * `;
 *
 */
export const ExportableViewContentContainer = styled.div.attrs(props => ({
  className: classes(
    VISUALIZATION_CONTENT_CONTAINER_CLASS_NAME,
    props.className
  ),
}))`
  width: 100%;
  height: 100%;
`;
